import Module from '../module';
import scroll from '../../libs/scroll/scroll';

import sliderListCutFactory, { PublicVarsInterface as SliderListCutSetupInterface } from '../../libs/slider/slider-list-cut';

interface OptionsInterface {
	cssId: {
		anim?: {
			homeHeroMediaCarouselArrowLeftId: string;
			homeHeroMediaCarouselArrowRightId: string;
			homeHeroMediaCarouselPagerWrapperId: string;
			homeHeroMediaCarouselListId: string;
		}
	},

	sliderListCutSetup?: SliderListCutSetupInterface

	slug: string
}

class Hero extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('Home Hero Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		if(!this.publicVars.sliderListCutSetup) {
			this.errorMsg('sliderSetup is not defined');
		} else {
			const slider = sliderListCutFactory.create();
			slider.init(this.publicVars.sliderListCutSetup);
		}

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.homeHeroMediaCarouselArrowLeftId || '', 'home_hero', { animCls: 'animate__fadeInLeft', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.homeHeroMediaCarouselArrowRightId || '', 'home_hero', { animCls: 'animate__fadeInRight', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.homeHeroMediaCarouselPagerWrapperId || '', 'home_hero', { animCls: 'animate__fadeIn', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.homeHeroMediaCarouselListId || '', 'home_hero', { animCls: 'animate__fadeIn', once: true});
	}

	bind() {
		this.msg('bind');
	}
}

export default Hero;